<template>
  <v-container
    class="home__container"
    fluid
    grid-list-md
  >
    Bem vindo ao Maestro CMS.
  </v-container>
</template>

<script>
export default {
  name: 'Home'
}
</script>
<style lang="stylus">
  .home__container {
    height: calc(100vh - 55px);
  }
</style>
